export function sineBell(options) {
    const { exponent = 1, offset = 0, end = 1, length } = options;
    if (length === undefined) {
        throw new Error('length options should exists for sineBell shape');
    }
    if (end < 0 || end > 1) {
        throw new Error(`the end parameter should be [0-1]`);
    }
    const c1 = Math.PI * offset;
    const c2 = (Math.PI * (end - offset)) / (length - 1);
    return (i) => Math.pow(Math.sin(c1 + c2 * i), exponent);
}
//# sourceMappingURL=sineBell.js.map